export function init_map(div) {

	let map_div = document.getElementById(div);
	map_div.style.display = 'none';

	var mapOptions = getMapOptions(7);
	let map = new google.maps.Map(map_div, mapOptions);
	google.maps.event.addListenerOnce( map, 'idle', function(){
		// do something only the first time the map is loaded
		EventBus.$emit('map_loaded',{
			name :div,
			map:map
		});
	});
	map_div.style.display = 'block';
}

export function  setCenter (lat, lng) {
	return new google.maps.LatLng(lat, lng)
}

export function processPoints (geometry, callback, thisArg) {
	if (geometry instanceof google.maps.LatLng) {
		callback.call(thisArg, geometry);

	} else if (geometry instanceof google.maps.Data.Point) {
		callback.call(thisArg, geometry.get());
	} else {
		geometry.getArray().forEach(function (g) {
			processPoints(g, callback, thisArg);
		});
	}
}


export function getPolygonBounds (polygon) {
	var bounds = new google.maps.LatLngBounds();
	polygon.getGeometry().getArray().forEach(function (path) {
		path.getArray().forEach(function (latLng) {
			bounds.extend(latLng);
		});
	});

	return bounds;
}

export function   getMapOptions (zoom) {
	const center = setCenter('50.46037159999999', '30.511092299999973');

	return {
		zoom: zoom,
		center: center,
		streetViewControl:false,
		mapTypeControl:true,
		mapTypeId: google.maps.MapTypeId.ROADMAP,
	}
}
